import { EntityDetailViewProps } from "../common/entity/EntityInterfaces";
import { EntityDetailPage, EntityDetailView } from "../common/entity/EntityDetailPage";
import { FileExportJobDetail } from "./FileExportJobsDetail";
import { EntityTablePage } from "../common/entity/EntityTablePage";
import { FileExportJobsTable } from "./Table/FileExportJobsTable";

// Detail
export const FileExportJobsDetailView = ({ id }: EntityDetailViewProps<"fileExportJobs">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"fileExportJobs"}>
      {(props) => <FileExportJobDetail {...props} />}
    </EntityDetailView>
  );
};

export const FileExportJobDetailsPage = () => {
  return <EntityDetailPage<"fileExportJobs"> isIntId>{(id) => <FileExportJobsDetailView id={id} />}</EntityDetailPage>;
};

export const FileExportJobsTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"fileExportJobs"}>{(props) => <FileExportJobsTable {...props} />}</EntityTablePage>
  );
};
